module.exports = __webpack_public_path__ + "img/icon-good-gray@3x.1be1e5c1.png";